// Returns a react-spring config object with a custom cubic easing function as react-spring only
// provides a linear easing function out of the box. Taken from https://gist.github.com/gre/1650294
export const springConfig = (duration: number) => ({
    duration,
    easing: (t: number) => (t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1),
});
